const sampleStore = {
    language: "german",
    darkmode: false,
    sounds: true,
}

export default sampleStore;
